// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,300,0,0);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Google Material Symbols (icons) */

.PostStory_postContainer__xY-3V {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);
  min-height: 100vh;
}

.PostStory_postWrapper__9e2ky {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(26, 95, 63, 0.15);
  border: 1px solid rgba(26, 95, 63, 0.08);
  margin-bottom: 40px;
}

/* ─── Material Icon base ─────────────────────────────── */
.PostStory_categoryIconSymbol__QP1r0,
.PostStory_defaultStoryIconSymbol__RIwFj,
.PostStory_audioPremiumIcon__BKAId,
.PostStory_relatedStoriesTitleIcon__71Kf2,
.PostStory_relatedStoryMediaIcon__wkMEB,
.PostStory_metaIcon__hbOV3,
.PostStory_statusIcon__kR7gL {
  font-family: "Material Symbols Outlined";
  font-weight: normal;
  font-style: normal;
  font-size: 22px;
  line-height: 1;
  display: inline-block;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
  -webkit-user-select: none;
          user-select: none;
}

/* ─── Breadcrumb ─────────────────────────────────────── */
.PostStory_breadcrumb__PdFUY {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
  font-size: 14px;
  color: #64748b;
  flex-wrap: wrap;
}

.PostStory_breadcrumbLink__skAxG {
  color: #1a5f3f;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.PostStory_breadcrumbLink__skAxG:hover {
  color: #22543d;
  text-decoration: underline;
}

.PostStory_breadcrumbSeparator__9SNM3 {
  color: #94a3b8;
  margin: 0 4px;
}

.PostStory_breadcrumbCurrent__eSTgc {
  color: #1e293b;
  font-weight: 600;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ─── Category Badge ─────────────────────────────────── */
.PostStory_categoryBadge__cpHgV {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  color: white;
  padding: 10px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 30px;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);
}

.PostStory_categoryIcon__7vDLn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.PostStory_categoryIconImg__UqBRp {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1); 
  display: block;
}

.PostStory_categoryText__TNDUx {
  color: #ffffff;
}

/* ─── Post Header ────────────────────────────────────── */
.PostStory_postHeader__1e-HQ {
  margin-bottom: 30px;
}

.PostStory_postTitle__oFNVj {
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  margin: 0;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ─── Post Meta ──────────────────────────────────────── */
.PostStory_postMeta__lFkz1 {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;
  padding: 20px;
  background: rgba(26, 95, 63, 0.05);
  border-radius: 16px;
  border: 1px solid rgba(26, 95, 63, 0.1);
  flex-wrap: wrap;
}

.PostStory_metaItem__C9V7l {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
}

.PostStory_metaIcon__hbOV3 {
  font-size: 18px;
  color: #1a5f3f;
}

.PostStory_metaText__JGLF7 {
  color: #334155;
}

.PostStory_metaSeparator__WxRMV {
  color: #94a3b8;
  font-weight: bold;
}

/* ─── Media Section (image / video / audio) ──────────── */
.PostStory_mediaSection__t1kEz {
  margin-bottom: 40px;
  text-align: center;
}

.PostStory_videoContainer__3nYb-,
.PostStory_imageContainer__wY8lN,
.PostStory_audioContainer__GGjYb {
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.15);
  border: 2px solid rgba(26, 95, 63, 0.1);
  position: relative;
  overflow: hidden;
}

.PostStory_videoPlayer__1H-7H {
  width: 100%;
  height: auto;
  max-height: 500px;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.2);
  background: #000;
  outline: none;
}

.PostStory_videoPlayer__1H-7H:focus {
  outline: 2px solid #1a5f3f;
  outline-offset: 2px;
}

.PostStory_storyImage__QmG9v {
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.2);
  background: #f1f5f9;
}

/* Audio player block */
.PostStory_audioPlayer__CB5hx {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.PostStory_audioThumbnail__fArvn {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);
  position: relative;
  overflow: hidden;
}

.PostStory_audioThumbnail__fArvn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);
}

.PostStory_audioPremiumIcon__BKAId {
  font-size: 48px;
  color: #ffffff;
  z-index: 1;
  position: relative;
}

.PostStory_audioElement__tMMwk {
  width: 100%;
  max-width: 560px;
}

/* Default (no media) state */
.PostStory_defaultMediaContainer__9h3aa {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 20px;
  border: 2px dashed rgba(26, 95, 63, 0.3);
}

.PostStory_defaultStoryIcon__ofH8t {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
}

.PostStory_defaultStoryIconSymbol__RIwFj {
  font-size: 64px;
  color: #1a5f3f;
}

.PostStory_mediaLoadingOverlay__uZBDf {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.PostStory_mediaLoadingSpinner__z6pZT {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #1a5f3f;
  border-radius: 50%;
  animation: PostStory_spin__53WaW 1s linear infinite;
}

/* ─── Post Content ───────────────────────────────────── */
.PostStory_postContent__0vrsv {
  margin-bottom: 40px;
}

.PostStory_contentHtml__qp4kG,
.PostStory_contentText__DcB\\+e {
  font-size: 18px;
  line-height: 1.8;
  color: #334155;
  text-align: justify;
}

.PostStory_contentHtml__qp4kG h1,
.PostStory_contentHtml__qp4kG h2,
.PostStory_contentHtml__qp4kG h3 {
  color: #1a5f3f;
  margin-top: 2em;
  margin-bottom: 10px;
}

.PostStory_contentHtml__qp4kG p {
  margin-bottom: 1.5em;
}

.PostStory_contentHtml__qp4kG a {
  color: #1a5f3f;
  text-decoration: none;
  font-weight: 600;
}

.PostStory_contentHtml__qp4kG a:hover {
  text-decoration: underline;
}

/* ─── Post Footer ────────────────────────────────────── */
.PostStory_postFooter__DcVXa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
  border-top: 2px solid rgba(26, 95, 63, 0.1);
  flex-wrap: wrap;
  gap: 20px;
}

.PostStory_postStatus__MxSm8 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
}

.PostStory_statusIcon__kR7gL {
  font-size: 18px;
  color: #1a5f3f;
}

.PostStory_statusText__MNiD2 {
  color: #16a34a;
}

.PostStory_navigationActions__4StjK {
  display: flex;
  gap: 16px;
}

.PostStory_backToListButton__dLMAr {
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.PostStory_backToListButton__dLMAr:hover {
  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(26, 95, 63, 0.4);
}

/* ─── Related Stories ────────────────────────────────── */
.PostStory_relatedStoriesSection__tuBNS {
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(26, 95, 63, 0.1);
  border: 1px solid rgba(26, 95, 63, 0.1);
}

.PostStory_relatedStoriesTitle__SRE0R {
  font-size: 24px;
  font-weight: 700;
  color: #1a5f3f;
  margin-bottom: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.PostStory_relatedStoriesTitleIcon__71Kf2 {
  font-size: 26px;
  color: #1a5f3f;
}

.PostStory_relatedStoriesGrid__fIVXp {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.PostStory_relatedStoryCard__xIQeS {
  display: block;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  position: relative;
}

.PostStory_relatedStoryCard__xIQeS::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.PostStory_relatedStoryCard__xIQeS:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);
  border-color: #1a5f3f;
}

.PostStory_relatedStoryCard__xIQeS:hover::before {
  transform: scaleX(1);
}

.PostStory_relatedStoryMedia__OHyzL {
  height: 150px;
  overflow: hidden;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.PostStory_relatedStoryMedia__OHyzL img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

/* Video / audio thumbnail placeholders with icons */
.PostStory_relatedStoryVideoThumb__aFKsK,
.PostStory_relatedStoryAudioThumb__RUBe\\+,
.PostStory_relatedStoryFallback__P5VvJ {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at center, rgba(255,255,255,0.12) 0%, transparent 70%);
}

.PostStory_relatedStoryMediaIcon__wkMEB {
  font-size: 48px;
  color: #ffffff;
  opacity: 0.9;
  transition: transform 0.3s ease;
}

.PostStory_relatedStoryCard__xIQeS:hover .PostStory_relatedStoryMediaIcon__wkMEB {
  transform: scale(1.15);
}

.PostStory_relatedStoryContent__xOSlD {
  padding: 20px;
}

.PostStory_relatedStoryTitle__CRdqn {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.PostStory_relatedStoryDate__odROf {
  font-size: 12px;
  color: #64748b;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* ─── Loading State ──────────────────────────────────── */
.PostStory_loadingContainer__13KlU {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 20px;
  margin: 20px auto;
  max-width: 600px;
}

.PostStory_loadingSpinner__dm580 {
  width: 50px;
  height: 50px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #1a5f3f;
  border-radius: 50%;
  animation: PostStory_spin__53WaW 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes PostStory_spin__53WaW {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.PostStory_loadingText__wRJDh {
  color: #1a5f3f;
  font-size: 18px;
  font-weight: 600;
}

/* ─── Error / 404 State ──────────────────────────────── */
.PostStory_errorContainer__LsFcO,
.PostStory_notFoundContainer__x0A7M {
  text-align: center;
  padding: 60px 40px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-radius: 20px;
  margin: 20px auto;
  max-width: 600px;
  border: 1px solid #fca5a5;
}

.PostStory_errorTitle__L917U,
.PostStory_notFoundTitle__MAfYR {
  font-size: 24px;
  font-weight: 700;
  color: #dc2626;
  margin-bottom: 16px;
}

.PostStory_errorMessage__29YX5,
.PostStory_notFoundMessage__QAlkX {
  font-size: 16px;
  color: #7f1d1d;
  margin-bottom: 30px;
  line-height: 1.6;
}

.PostStory_errorActions__gmRBj {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.PostStory_backButton__eaJ3s,
.PostStory_retryButton__NMlML {
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.PostStory_backButton__eaJ3s {
  background: #6b7280;
  color: white;
}

.PostStory_backButton__eaJ3s:hover {
  background: #4b5563;
  transform: translateY(-2px);
}

.PostStory_retryButton__NMlML {
  background: #dc2626;
  color: white;
}

.PostStory_retryButton__NMlML:hover {
  background: #b91c1c;
  transform: translateY(-2px);
}

/* ─── Responsive ─────────────────────────────────────── */
@media (max-width: 768px) {
  .PostStory_postContainer__xY-3V {
    padding: 15px;
  }

  .PostStory_postWrapper__9e2ky,
  .PostStory_relatedStoriesSection__tuBNS {
    padding: 25px;
  }

  .PostStory_postTitle__oFNVj {
    font-size: 24px;
  }

  .PostStory_postMeta__lFkz1 {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .PostStory_postFooter__DcVXa {
    flex-direction: column;
    text-align: center;
  }

  .PostStory_relatedStoriesGrid__fIVXp {
    grid-template-columns: 1fr;
  }

  .PostStory_audioThumbnail__fArvn {
    width: 100px;
    height: 100px;
  }

  .PostStory_audioPremiumIcon__BKAId {
    font-size: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Posts pages/PostStory.module.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAGpC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;;;;;;;EAOE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EAEd,6BAA6B;EAC7B,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,wFAAwF;AAC1F;;AAEA;EACE,eAAe;EACf,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,mDAAkC;AACpC;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,2DAA2D;AAC3D;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;;;EAGE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yFAAyF;AAC3F;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,mDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Google Material Symbols (icons) */\n@import url(\"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,300,0,0\");\n\n.postContainer {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  direction: rtl;\n  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);\n  min-height: 100vh;\n}\n\n.postWrapper {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 8px 32px rgba(26, 95, 63, 0.15);\n  border: 1px solid rgba(26, 95, 63, 0.08);\n  margin-bottom: 40px;\n}\n\n/* ─── Material Icon base ─────────────────────────────── */\n.categoryIconSymbol,\n.defaultStoryIconSymbol,\n.audioPremiumIcon,\n.relatedStoriesTitleIcon,\n.relatedStoryMediaIcon,\n.metaIcon,\n.statusIcon {\n  font-family: \"Material Symbols Outlined\";\n  font-weight: normal;\n  font-style: normal;\n  font-size: 22px;\n  line-height: 1;\n  display: inline-block;\n  letter-spacing: normal;\n  text-transform: none;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: \"liga\";\n  font-feature-settings: \"liga\";\n  -webkit-font-smoothing: antialiased;\n  user-select: none;\n}\n\n/* ─── Breadcrumb ─────────────────────────────────────── */\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 30px;\n  font-size: 14px;\n  color: #64748b;\n  flex-wrap: wrap;\n}\n\n.breadcrumbLink {\n  color: #1a5f3f;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.breadcrumbLink:hover {\n  color: #22543d;\n  text-decoration: underline;\n}\n\n.breadcrumbSeparator {\n  color: #94a3b8;\n  margin: 0 4px;\n}\n\n.breadcrumbCurrent {\n  color: #1e293b;\n  font-weight: 600;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ─── Category Badge ─────────────────────────────────── */\n.categoryBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\n  color: white;\n  padding: 10px 18px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);\n}\n\n.categoryIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.categoryIconImg {\n  width: 20px;\n  height: 20px;\n  filter: brightness(0) invert(1); \n  display: block;\n}\n\n.categoryText {\n  color: #ffffff;\n}\n\n/* ─── Post Header ────────────────────────────────────── */\n.postHeader {\n  margin-bottom: 30px;\n}\n\n.postTitle {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1a202c;\n  line-height: 1.3;\n  margin: 0;\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* ─── Post Meta ──────────────────────────────────────── */\n.postMeta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 40px;\n  padding: 20px;\n  background: rgba(26, 95, 63, 0.05);\n  border-radius: 16px;\n  border: 1px solid rgba(26, 95, 63, 0.1);\n  flex-wrap: wrap;\n}\n\n.metaItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.metaIcon {\n  font-size: 18px;\n  color: #1a5f3f;\n}\n\n.metaText {\n  color: #334155;\n}\n\n.metaSeparator {\n  color: #94a3b8;\n  font-weight: bold;\n}\n\n/* ─── Media Section (image / video / audio) ──────────── */\n.mediaSection {\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.videoContainer,\n.imageContainer,\n.audioContainer {\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.15);\n  border: 2px solid rgba(26, 95, 63, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.videoPlayer {\n  width: 100%;\n  height: auto;\n  max-height: 500px;\n  border-radius: 16px;\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.2);\n  background: #000;\n  outline: none;\n}\n\n.videoPlayer:focus {\n  outline: 2px solid #1a5f3f;\n  outline-offset: 2px;\n}\n\n.storyImage {\n  width: 100%;\n  height: auto;\n  max-height: 500px;\n  object-fit: cover;\n  border-radius: 16px;\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.2);\n  background: #f1f5f9;\n}\n\n/* Audio player block */\n.audioPlayer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.audioThumbnail {\n  width: 120px;\n  height: 120px;\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.audioThumbnail::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);\n}\n\n.audioPremiumIcon {\n  font-size: 48px;\n  color: #ffffff;\n  z-index: 1;\n  position: relative;\n}\n\n.audioElement {\n  width: 100%;\n  max-width: 560px;\n}\n\n/* Default (no media) state */\n.defaultMediaContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\n  border-radius: 20px;\n  border: 2px dashed rgba(26, 95, 63, 0.3);\n}\n\n.defaultStoryIcon {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.7;\n}\n\n.defaultStoryIconSymbol {\n  font-size: 64px;\n  color: #1a5f3f;\n}\n\n.mediaLoadingOverlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n}\n\n.mediaLoadingSpinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #1a5f3f;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* ─── Post Content ───────────────────────────────────── */\n.postContent {\n  margin-bottom: 40px;\n}\n\n.contentHtml,\n.contentText {\n  font-size: 18px;\n  line-height: 1.8;\n  color: #334155;\n  text-align: justify;\n}\n\n.contentHtml h1,\n.contentHtml h2,\n.contentHtml h3 {\n  color: #1a5f3f;\n  margin-top: 2em;\n  margin-bottom: 10px;\n}\n\n.contentHtml p {\n  margin-bottom: 1.5em;\n}\n\n.contentHtml a {\n  color: #1a5f3f;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.contentHtml a:hover {\n  text-decoration: underline;\n}\n\n/* ─── Post Footer ────────────────────────────────────── */\n.postFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 30px;\n  border-top: 2px solid rgba(26, 95, 63, 0.1);\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.postStatus {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.statusIcon {\n  font-size: 18px;\n  color: #1a5f3f;\n}\n\n.statusText {\n  color: #16a34a;\n}\n\n.navigationActions {\n  display: flex;\n  gap: 16px;\n}\n\n.backToListButton {\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\n  color: white;\n  text-decoration: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.3);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.backToListButton:hover {\n  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(26, 95, 63, 0.4);\n}\n\n/* ─── Related Stories ────────────────────────────────── */\n.relatedStoriesSection {\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 8px 32px rgba(26, 95, 63, 0.1);\n  border: 1px solid rgba(26, 95, 63, 0.1);\n}\n\n.relatedStoriesTitle {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1a5f3f;\n  margin-bottom: 30px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.relatedStoriesTitleIcon {\n  font-size: 26px;\n  color: #1a5f3f;\n}\n\n.relatedStoriesGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.relatedStoryCard {\n  display: block;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n\n.relatedStoryCard::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);\n  transform: scaleX(0);\n  transform-origin: center;\n  transition: transform 0.3s ease;\n}\n\n.relatedStoryCard:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);\n  border-color: #1a5f3f;\n}\n\n.relatedStoryCard:hover::before {\n  transform: scaleX(1);\n}\n\n.relatedStoryMedia {\n  height: 150px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.relatedStoryMedia img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n/* Video / audio thumbnail placeholders with icons */\n.relatedStoryVideoThumb,\n.relatedStoryAudioThumb,\n.relatedStoryFallback {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: radial-gradient(circle at center, rgba(255,255,255,0.12) 0%, transparent 70%);\n}\n\n.relatedStoryMediaIcon {\n  font-size: 48px;\n  color: #ffffff;\n  opacity: 0.9;\n  transition: transform 0.3s ease;\n}\n\n.relatedStoryCard:hover .relatedStoryMediaIcon {\n  transform: scale(1.15);\n}\n\n.relatedStoryContent {\n  padding: 20px;\n}\n\n.relatedStoryTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a202c;\n  margin: 0 0 8px 0;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.relatedStoryDate {\n  font-size: 12px;\n  color: #64748b;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* ─── Loading State ──────────────────────────────────── */\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\n  border-radius: 20px;\n  margin: 20px auto;\n  max-width: 600px;\n}\n\n.loadingSpinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #1a5f3f;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loadingText {\n  color: #1a5f3f;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n/* ─── Error / 404 State ──────────────────────────────── */\n.errorContainer,\n.notFoundContainer {\n  text-align: center;\n  padding: 60px 40px;\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border-radius: 20px;\n  margin: 20px auto;\n  max-width: 600px;\n  border: 1px solid #fca5a5;\n}\n\n.errorTitle,\n.notFoundTitle {\n  font-size: 24px;\n  font-weight: 700;\n  color: #dc2626;\n  margin-bottom: 16px;\n}\n\n.errorMessage,\n.notFoundMessage {\n  font-size: 16px;\n  color: #7f1d1d;\n  margin-bottom: 30px;\n  line-height: 1.6;\n}\n\n.errorActions {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n}\n\n.backButton,\n.retryButton {\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.backButton {\n  background: #6b7280;\n  color: white;\n}\n\n.backButton:hover {\n  background: #4b5563;\n  transform: translateY(-2px);\n}\n\n.retryButton {\n  background: #dc2626;\n  color: white;\n}\n\n.retryButton:hover {\n  background: #b91c1c;\n  transform: translateY(-2px);\n}\n\n/* ─── Responsive ─────────────────────────────────────── */\n@media (max-width: 768px) {\n  .postContainer {\n    padding: 15px;\n  }\n\n  .postWrapper,\n  .relatedStoriesSection {\n    padding: 25px;\n  }\n\n  .postTitle {\n    font-size: 24px;\n  }\n\n  .postMeta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .postFooter {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .relatedStoriesGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .audioThumbnail {\n    width: 100px;\n    height: 100px;\n  }\n\n  .audioPremiumIcon {\n    font-size: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"postContainer": `PostStory_postContainer__xY-3V`,
	"postWrapper": `PostStory_postWrapper__9e2ky`,
	"categoryIconSymbol": `PostStory_categoryIconSymbol__QP1r0`,
	"defaultStoryIconSymbol": `PostStory_defaultStoryIconSymbol__RIwFj`,
	"audioPremiumIcon": `PostStory_audioPremiumIcon__BKAId`,
	"relatedStoriesTitleIcon": `PostStory_relatedStoriesTitleIcon__71Kf2`,
	"relatedStoryMediaIcon": `PostStory_relatedStoryMediaIcon__wkMEB`,
	"metaIcon": `PostStory_metaIcon__hbOV3`,
	"statusIcon": `PostStory_statusIcon__kR7gL`,
	"breadcrumb": `PostStory_breadcrumb__PdFUY`,
	"breadcrumbLink": `PostStory_breadcrumbLink__skAxG`,
	"breadcrumbSeparator": `PostStory_breadcrumbSeparator__9SNM3`,
	"breadcrumbCurrent": `PostStory_breadcrumbCurrent__eSTgc`,
	"categoryBadge": `PostStory_categoryBadge__cpHgV`,
	"categoryIcon": `PostStory_categoryIcon__7vDLn`,
	"categoryIconImg": `PostStory_categoryIconImg__UqBRp`,
	"categoryText": `PostStory_categoryText__TNDUx`,
	"postHeader": `PostStory_postHeader__1e-HQ`,
	"postTitle": `PostStory_postTitle__oFNVj`,
	"postMeta": `PostStory_postMeta__lFkz1`,
	"metaItem": `PostStory_metaItem__C9V7l`,
	"metaText": `PostStory_metaText__JGLF7`,
	"metaSeparator": `PostStory_metaSeparator__WxRMV`,
	"mediaSection": `PostStory_mediaSection__t1kEz`,
	"videoContainer": `PostStory_videoContainer__3nYb-`,
	"imageContainer": `PostStory_imageContainer__wY8lN`,
	"audioContainer": `PostStory_audioContainer__GGjYb`,
	"videoPlayer": `PostStory_videoPlayer__1H-7H`,
	"storyImage": `PostStory_storyImage__QmG9v`,
	"audioPlayer": `PostStory_audioPlayer__CB5hx`,
	"audioThumbnail": `PostStory_audioThumbnail__fArvn`,
	"audioElement": `PostStory_audioElement__tMMwk`,
	"defaultMediaContainer": `PostStory_defaultMediaContainer__9h3aa`,
	"defaultStoryIcon": `PostStory_defaultStoryIcon__ofH8t`,
	"mediaLoadingOverlay": `PostStory_mediaLoadingOverlay__uZBDf`,
	"mediaLoadingSpinner": `PostStory_mediaLoadingSpinner__z6pZT`,
	"spin": `PostStory_spin__53WaW`,
	"postContent": `PostStory_postContent__0vrsv`,
	"contentHtml": `PostStory_contentHtml__qp4kG`,
	"contentText": `PostStory_contentText__DcB+e`,
	"postFooter": `PostStory_postFooter__DcVXa`,
	"postStatus": `PostStory_postStatus__MxSm8`,
	"statusText": `PostStory_statusText__MNiD2`,
	"navigationActions": `PostStory_navigationActions__4StjK`,
	"backToListButton": `PostStory_backToListButton__dLMAr`,
	"relatedStoriesSection": `PostStory_relatedStoriesSection__tuBNS`,
	"relatedStoriesTitle": `PostStory_relatedStoriesTitle__SRE0R`,
	"relatedStoriesGrid": `PostStory_relatedStoriesGrid__fIVXp`,
	"relatedStoryCard": `PostStory_relatedStoryCard__xIQeS`,
	"relatedStoryMedia": `PostStory_relatedStoryMedia__OHyzL`,
	"relatedStoryVideoThumb": `PostStory_relatedStoryVideoThumb__aFKsK`,
	"relatedStoryAudioThumb": `PostStory_relatedStoryAudioThumb__RUBe+`,
	"relatedStoryFallback": `PostStory_relatedStoryFallback__P5VvJ`,
	"relatedStoryContent": `PostStory_relatedStoryContent__xOSlD`,
	"relatedStoryTitle": `PostStory_relatedStoryTitle__CRdqn`,
	"relatedStoryDate": `PostStory_relatedStoryDate__odROf`,
	"loadingContainer": `PostStory_loadingContainer__13KlU`,
	"loadingSpinner": `PostStory_loadingSpinner__dm580`,
	"loadingText": `PostStory_loadingText__wRJDh`,
	"errorContainer": `PostStory_errorContainer__LsFcO`,
	"notFoundContainer": `PostStory_notFoundContainer__x0A7M`,
	"errorTitle": `PostStory_errorTitle__L917U`,
	"notFoundTitle": `PostStory_notFoundTitle__MAfYR`,
	"errorMessage": `PostStory_errorMessage__29YX5`,
	"notFoundMessage": `PostStory_notFoundMessage__QAlkX`,
	"errorActions": `PostStory_errorActions__gmRBj`,
	"backButton": `PostStory_backButton__eaJ3s`,
	"retryButton": `PostStory_retryButton__NMlML`
};
export default ___CSS_LOADER_EXPORT___;
